import { Profile } from '@zapier/shared-entities';

export default function shouldRouteToStandaloneEditor(state) {
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return (
    Profile.selectors.isSwitchOn('editor_ssr_opt-in', currentProfile) &&
    !Profile.selectors.isSwitchOn('editor_ssr_opt-out', currentProfile)
  );
}
